import React from 'react';

/** ตารางดิบ — ใช้เมื่อเนื้อหาไม่เข้ารูปแบบ FieldsTable */
const ApiTable: React.FC<{ headers: React.ReactNode[]; rows: React.ReactNode[][] }> = ({ headers, rows }) => (
  <div className="overflow-x-auto mb-5 rounded-xl border border-gray-200/70 dark:border-slate-700">
    <table className="api-docs-table min-w-full text-sm">
      <thead>
        <tr className="bg-gray-50/80 dark:bg-slate-700/50">
          {headers.map((h, i) => (
            <th key={i} className="px-4 py-3 text-left font-semibold text-gray-500 dark:text-slate-400 text-xs uppercase tracking-wider">{h}</th>
          ))}
        </tr>
      </thead>
      <tbody className="divide-y divide-gray-100 dark:divide-slate-700 text-gray-700 dark:text-slate-200">
        {rows.map((row, i) => (
          <tr key={i} className="transition-colors">
            {row.map((cell, j) => (
              <td key={j} className="px-4 py-3">{cell}</td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export default ApiTable;
